import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/icon/Shield-Done.png'
import _imports_1 from '@/assets/img/detail-resi-notfound.png'


const _hoisted_1 = { id: "dialog-detail-resi" }
const _hoisted_2 = {
  class: "flex w-full justify-between items-center px-2 pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_3 = { class: "font-semibold text-xl text-black" }
const _hoisted_4 = { class: "font-semibold color-blue-grey" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Tekan ")
const _hoisted_6 = /*#__PURE__*/_createVNode("b", null, "Esc", -1)
const _hoisted_7 = { class: "background-grey-lighten-5 px-5 py-5 mb-4 rounded-lg" }
const _hoisted_8 = { class: "flex flex-wrap lg:flex-nowrap w-full justify-between" }
const _hoisted_9 = { class: "py-2 w-full lg:w-auto mr-2" }
const _hoisted_10 = { class: "font-bold text-2xl break-all" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = {
  key: 0,
  class: "color-primary"
}
const _hoisted_13 = { class: "font-semibold mb-1 color-blue-grey" }
const _hoisted_14 = { class: "font-semibold mb-1 color-blue-grey" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col  items-center"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Ke Manifest Jadwal")
const _hoisted_17 = { class: "lg:w-auto w-full py-2 flex items-center" }
const _hoisted_18 = { class: "mr-2" }
const _hoisted_19 = { class: "font-semibold lg:text-base md:text-base text-sm px-2 rounded-lg background-blue-grey-lighten-5 border-radius-blue-grey-darken-1 color-blue-grey" }
const _hoisted_20 = { class: "grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2" }
const _hoisted_21 = { class: "lg:mb-0 md:mb-0 mb-4" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-1 color-blue-grey" }, "Pengirim", -1)
const _hoisted_23 = { class: "font-semibold mb-1 break-all" }
const _hoisted_24 = { class: "font-semibold mb-1 break-all" }
const _hoisted_25 = { class: "lg:hidden md:hidden block" }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-2 color-blue-grey" }, "Diskon Pelanggan : ", -1)
const _hoisted_27 = { class: "color-red font-semibold" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-1 color-blue-grey" }, "Penerima", -1)
const _hoisted_30 = { class: "font-semibold mb-1 break-all" }
const _hoisted_31 = { class: "font-semibold mb-1 break-all" }
const _hoisted_32 = { class: "lg:hidden md:hidden block" }
const _hoisted_33 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-2 color-blue-grey" }, "Total Biaya Tambahan : ", -1)
const _hoisted_34 = { class: "color-red font-semibold" }
const _hoisted_35 = { class: "grid-cols-2 gap-2 lg:grid md:grid hidden" }
const _hoisted_36 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-4 color-blue-grey" }, "Total Biaya Tambahan : ", -1)
const _hoisted_37 = { class: "color-red font-semibold" }
const _hoisted_38 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-4 color-blue-grey" }, "Diskon Pelanggan : ", -1)
const _hoisted_39 = { class: "color-red font-semibold" }
const _hoisted_40 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-4 color-blue-grey" }, "Keterangan Biaya Tambahan:", -1)
const _hoisted_42 = { class: "col-span-2" }
const _hoisted_43 = { class: "font-bold" }
const _hoisted_44 = { class: "color-blue-grey" }
const _hoisted_45 = { class: "font-bold" }
const _hoisted_46 = { class: "grid gap-4 grid-cols-1 sm:grid-cols-2 mb-4 background-blue-grey-lighten-5 rounded-lg" }
const _hoisted_47 = { class: " rounded-lg px-5 py-3" }
const _hoisted_48 = { class: "flex font-bold text-base mb-4" }
const _hoisted_49 = /*#__PURE__*/_createVNode("img", {
  alt: "total pendapatan",
  src: _imports_0,
  class: "lg:w-6 md:w-6 w-3 mr-2"
}, null, -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Asuransi ")
const _hoisted_51 = { class: "color-blue-grey ml-1" }
const _hoisted_52 = { class: "flex" }
const _hoisted_53 = { class: "mb-2 flex-auto" }
const _hoisted_54 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Harga Barang", -1)
const _hoisted_55 = { class: "flex" }
const _hoisted_56 = { class: "mb-2 flex-auto" }
const _hoisted_57 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "No Asuransi", -1)
const _hoisted_58 = { class: "mb-2 flex-auto" }
const _hoisted_59 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Total Asuransi", -1)
const _hoisted_60 = { class: " rounded-lg px-5 py-3 border-l-2 border-dashed border-gray-400" }
const _hoisted_61 = { class: "flex" }
const _hoisted_62 = { class: "mb-2 flex-auto" }
const _hoisted_63 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Ket. Pengakuan Barang", -1)
const _hoisted_64 = {
  key: 0,
  class: ""
}
const _hoisted_65 = { class: "flex w-full container-labels-scroling" }
const _hoisted_66 = /*#__PURE__*/_createVNode("div", {
  class: "flex items-center justify-between mx-2 pt-2 pb-4",
  style: {"border-bottom":"1px solid #ECEFF1"}
}, [
  /*#__PURE__*/_createVNode("p", null, "Biaya Pengembalian"),
  /*#__PURE__*/_createVNode("p", { class: "font-normal color-blue-grey text-sm" }, "*Sudah termasuk biaya tambahan dan diskon")
], -1)
const _hoisted_67 = { class: "flex items-center justify-between mx-2 pt-4 pb-2 " }
const _hoisted_68 = /*#__PURE__*/_createVNode("p", { class: "font-semibold color-blue-grey" }, "Yang Harus Dikembalikan ", -1)
const _hoisted_69 = { class: "color-red font-semibold" }
const _hoisted_70 = /*#__PURE__*/_createVNode("div", { class: "flex items-center p-4 w-full justify-between" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-normal text-lg" }, "Barang Pada Resi")
], -1)
const _hoisted_71 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_72 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_73 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_74 = {
  key: 3,
  class: "mb-5"
}
const _hoisted_75 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, "Keterangan", -1)
const _hoisted_76 = {
  key: 0,
  class: "p-error"
}
const _hoisted_77 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "sm:max-w-sm mx-auto"
}, null, -1)
const _hoisted_79 = { class: "sm:max-w-sm mx-auto text-center font-semibold" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode("Oops, data tidak ditemukan ")
const _hoisted_81 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" Coba lagi! ")
const _hoisted_83 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_84 = {
  key: 2,
  class: "sm:max-w-sm mx-auto text-center font-semibold"
}
const _hoisted_85 = {
  key: 0,
  class: "w-full text-left py-4"
}
const _hoisted_86 = /*#__PURE__*/_createTextVNode("Refund/Retur")
const _hoisted_87 = /*#__PURE__*/_createTextVNode("Batalkan")
const _hoisted_88 = {
  key: 1,
  class: "w-full justify-between flex items-center",
  style: {}
}
const _hoisted_89 = /*#__PURE__*/_createTextVNode("Konfirmasi Resi")
const _hoisted_90 = /*#__PURE__*/_createTextVNode("Proses Transaksi")
const _hoisted_91 = { key: 2 }
const _hoisted_92 = /*#__PURE__*/_createVNode("span", { class: "color-primary font-normal mr-2 text-xl" }, "Grand Total", -1)
const _hoisted_93 = { class: "font-normal color-blue-grey text-sm text-left" }
const _hoisted_94 = { class: "color-primary font-bold text-3xl pb-1" }
const _hoisted_95 = /*#__PURE__*/_createVNode("p", { class: "font-normal color-blue-grey text-sm" }, "*Sudah termasuk biaya tambahan dan diskon", -1)
const _hoisted_96 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_97 = { class: "grid  justify-items-center" }
const _hoisted_98 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_focus = _resolveDirective("focus")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Dialog, {
      visible: $setup.dialogDetailResi,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ($setup.dialogDetailResi = $event)),
      class: "dialog-voucher",
      modal: true,
      dismissableMask: true
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", null, [
            _createVNode("h6", _hoisted_3, _toDisplayString(($setup.onRefund) ? 'Refund / Retur Resi' : 'Detail Resi'), 1),
            _createVNode("small", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createTextVNode(" untuk menutup halaman " + _toDisplayString(($setup.onRefund) ? 'Refund / Retur Resi' : 'Detail Resi'), 1)
            ])
          ]),
          _createVNode("i", {
            class: "pi pi-times text-black cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.hidedialogDetailResi()))
          })
        ])
      ]),
      footer: _withCtx(() => [
        ($setup.isValidData)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              ($setup.onRefund)
                ? (_openBlock(), _createBlock("div", _hoisted_85, [
                    _createVNode(_component_Button, {
                      class: "btn-primary text-black mr-3 px-10 py-1",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.submitData(!$setup.v$.$invalid)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_86
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Button, {
                      class: "btn-secondary text-black px-10 py-1",
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.hidedialogDetailResi()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_87
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_88, [
                    ($setup.isFromGuid && $setup.data.FirstScanDate == null)
                      ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          class: "btn-primary text-black mr-3 px-10 py-1",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.submitScanResi()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_89
                          ]),
                          _: 1
                        }, 512)), [
                          [_directive_focus]
                        ])
                      : ($props.module === 'delivery-draft')
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.onProcessTrans()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_90
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock("div", _hoisted_91, [
                            _hoisted_92,
                            _createVNode("p", _hoisted_93, _toDisplayString($setup.data.JenisPembayaran.Nama), 1)
                          ])),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_94, "Rp. " + _toDisplayString(new Number($setup.data.GrandTotal).toLocaleString("id-ID")), 1),
                      _hoisted_95
                    ])
                  ]))
            ], 64))
          : (_openBlock(), _createBlock("div", _hoisted_96, [
              _createVNode("div", _hoisted_97, [
                _withDirectives(_createVNode(_component_Button, {
                  class: "btn-primary text-black mr-3 px-10 py-1",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.hidedialogDetailResi()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_98
                  ]),
                  _: 1
                }, 512), [
                  [_directive_focus]
                ])
              ])
            ]))
      ]),
      default: _withCtx(() => [
        ($setup.isValidData && !$setup.isLoading)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("p", _hoisted_10, "#" + _toDisplayString($setup.data.Resi), 1),
                    _createVNode("span", _hoisted_11, [
                      ($setup.data.AgenAsal && $setup.data.AgenTujuan)
                        ? (_openBlock(), _createBlock("p", _hoisted_12, _toDisplayString($setup.data.AgenAsal.Kota.Nama) + " - " + _toDisplayString($setup.data.AgenTujuan.Kota.Nama), 1))
                        : _createCommentVNode("", true),
                      ($setup.data.TransJadwalHd )
                        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            _createVNode("p", _hoisted_13, _toDisplayString($setup.data.TransJadwalHd.KodeJadwal), 1),
                            _createVNode("p", _hoisted_14, "Tanggal Berangkat : " + _toDisplayString($setup.moment($setup.data.TransJadwalHd.TanggalAktif).format('DD MMM YYYY')), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  ($setup.data.StatusPengiriman)
                    ? (_openBlock(), _createBlock("div", _hoisted_15, [
                        ($setup.data.StatusPengiriman.Status ==='Diproses' )
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              class: "px-2 inline-block rounded-md font-semibold text-base",
                              onClick: $setup.openManifestJadwal
                            }, {
                              default: _withCtx(() => [
                                _hoisted_16
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_17, [
                          _createVNode("div", _hoisted_18, [
                            _createVNode("p", {
                              class: "px-2 inline-block rounded-md font-semibold text-base break-all",
                              style: { backgroundColor: $setup.data.StatusPengiriman.Attribute1 ?? 'black', color: $setup.data.StatusPengiriman.Attribute2 ?? 'white', border: `1px solid ${$setup.data.StatusPengiriman.Attribute2 ?? 'white'}` }
                            }, _toDisplayString($setup.data.StatusPengiriman.Status), 5)
                          ]),
                          _createVNode("div", _hoisted_19, _toDisplayString($setup.data.TipePengiriman), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode("p", _hoisted_23, _toDisplayString($setup.data.NamaPengirim), 1),
                    _createVNode("p", _hoisted_24, _toDisplayString(`${$setup.data.AlamatPengirim} (${$setup.data.HpPengirim})`), 1),
                    _createVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createVNode("p", _hoisted_27, "Rp. " + _toDisplayString(new Number($setup.data.Diskon).toLocaleString("id-ID")), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode("p", _hoisted_30, _toDisplayString($setup.data.NamaPenerima), 1),
                    _createVNode("p", _hoisted_31, _toDisplayString(`${$setup.data.AlamatPenerima} (${$setup.data.HpPenerima})`), 1),
                    _createVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createVNode("p", _hoisted_34, "Rp. " + _toDisplayString(new Number($setup.data.BiayaTambahan).toLocaleString("id-ID")), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", null, [
                    _hoisted_36,
                    _createVNode("p", _hoisted_37, "Rp. " + _toDisplayString(new Number($setup.data.BiayaTambahan).toLocaleString("id-ID")), 1)
                  ]),
                  _createVNode("div", null, [
                    _hoisted_38,
                    _createVNode("p", _hoisted_39, "Rp. " + _toDisplayString(new Number($setup.data.Diskon).toLocaleString("id-ID")), 1)
                  ])
                ]),
                ($setup.data.TransPengirimanHdBiayaTambahans.length > 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_40, [
                      _hoisted_41,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.data.TransPengirimanHdBiayaTambahans, (datas) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "grid grid-cols-3 gap-2 mt-2",
                          key: datas.Id
                        }, [
                          _createVNode("div", _hoisted_42, [
                            _createVNode("p", _hoisted_43, _toDisplayString(datas?.MsBiayaTambahan?.Nama), 1),
                            _createVNode("p", _hoisted_44, _toDisplayString(`(${datas.Keterangan})`), 1)
                          ]),
                          _createVNode("p", _hoisted_45, "Rp " + _toDisplayString(datas.Nominal), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_46, [
                _createVNode("div", _hoisted_47, [
                  _createVNode("p", _hoisted_48, [
                    _hoisted_49,
                    _hoisted_50,
                    _createVNode("span", _hoisted_51, _toDisplayString($setup.dataAnsuransi.nama??'-'), 1)
                  ]),
                  _createVNode("div", _hoisted_52, [
                    _createVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _createVNode("p", null, "Rp. " + _toDisplayString(new Number($setup.data.PengakuanNilaiBarang??0).toLocaleString("id-ID")), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_55, [
                    _createVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createVNode("p", null, _toDisplayString($setup.data.NoReferensiAsuransi??'-'), 1)
                    ]),
                    _createVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createVNode("p", null, "Rp. " + _toDisplayString(new Number($setup.data.TotalAsuransi??0).toLocaleString("id-ID")), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_60, [
                  _createVNode("div", _hoisted_61, [
                    _createVNode("div", _hoisted_62, [
                      _hoisted_63,
                      _createVNode("p", null, _toDisplayString($setup.data.KeteranganBiayaTambahan??'-'), 1)
                    ])
                  ])
                ])
              ]),
              ($setup.data.TransStockLabels)
                ? (_openBlock(), _createBlock("div", _hoisted_64, [
                    _createVNode("div", _hoisted_65, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.data.TransStockLabels, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: 'label-'+ index,
                          class: "label-ticket font-bold text-sm mr-2",
                          style: { background: _ctx.$detectBackgroundLabel(item.Label), color: _ctx.$textColorFromHex(_ctx.$detectBackgroundLabel(item.Label)) }
                        }, _toDisplayString(item.KodeLabel), 5))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($setup.onRefund)
                ? (_openBlock(), _createBlock(_component_Card, {
                    key: 1,
                    class: "card-no-shadow card-p-0 mb-5 px-4 py-3"
                  }, {
                    content: _withCtx(() => [
                      _hoisted_66,
                      _createVNode("div", _hoisted_67, [
                        _hoisted_68,
                        _createVNode("p", _hoisted_69, "Rp. " + _toDisplayString(new Number($setup.data.GrandTotal).toLocaleString("id-ID")), 1)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($setup.data.TransPengirimanDetails)
                ? (_openBlock(), _createBlock(_component_Card, {
                    key: 2,
                    class: "card-no-shadow card-p-0 mb-5"
                  }, {
                    content: _withCtx(() => [
                      _hoisted_70,
                      _createVNode(_component_DataTable, {
                        value: $setup.data.TransPengirimanDetails,
                        class: "table-og body-td-x-0",
                        responsiveLayout: "scroll"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, { header: "Satuan" }, {
                            body: _withCtx((slotProps) => [
                              _createVNode("p", _hoisted_71, _toDisplayString(slotProps.data.Berat), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, { header: "Kategori Barang" }, {
                            body: _withCtx((slotProps) => [
                              _createVNode("p", _hoisted_72, _toDisplayString(slotProps.data.KategoriBarang.Nama), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, { header: "Biaya Barang" }, {
                            body: _withCtx((slotProps) => [
                              _createVNode("p", _hoisted_73, "Rp. " + _toDisplayString(new Number(slotProps.data.TotalHarga).toLocaleString("id-ID")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($setup.onRefund)
                ? (_openBlock(), _createBlock("div", _hoisted_74, [
                    _hoisted_75,
                    _createVNode(_component_Textarea, {
                      autoResize: true,
                      modelValue: $setup.v$.description.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.v$.description.$model = $event)),
                      class: "w-full input-primary",
                      placeholder: "keterangan refund",
                      rows: "5"
                    }, null, 8, ["modelValue"]),
                    (($setup.v$.description.$invalid && $setup.submitted) || $setup.v$.description.$pending.$response)
                      ? (_openBlock(), _createBlock("small", _hoisted_76, _toDisplayString($setup.v$.description.required.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (!$setup.isValidData && !$setup.isLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_77, [
                _hoisted_78,
                _createVNode("p", _hoisted_79, [
                  _hoisted_80,
                  _hoisted_81,
                  _hoisted_82,
                  _hoisted_83,
                  _createTextVNode(" " + _toDisplayString($setup.resMessage), 1)
                ])
              ]))
            : (_openBlock(), _createBlock("p", _hoisted_84, "Tunggu Sebentar . . ."))
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}